import { render, staticRenderFns } from "./hives.vue?vue&type=template&id=1ce820f8&"
import script from "./hives.vue?vue&type=script&lang=js&"
export * from "./hives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports